import React from 'react';
import { Avatar } from '@mui/material';
import { getUserInitials, resolveAvatarColor } from '../utils/userAvatar';

const AVATAR_INITIALS_COLOR = '#F4F6FB';

const UserAvatar = ({
  firstName,
  lastName,
  email,
  name,
  avatarColor,
  size = 26,
  sx,
  ...rest
}) => {
  const initials = getUserInitials(firstName, lastName, email || name);
  const bgcolor = resolveAvatarColor(avatarColor);
  const fontSize = size <= 22 ? '0.65rem' : size <= 26 ? '0.7rem' : '0.875rem';

  return (
    <Avatar
      {...rest}
      sx={{
        width: size,
        height: size,
        fontSize,
        bgcolor,
        color: AVATAR_INITIALS_COLOR,
        fontWeight: 500,
        ...sx,
      }}
    >
      {initials}
    </Avatar>
  );
};

export default UserAvatar;
